import { notice } from 'feature/notice/NoticeController'
import { makeAutoObservable } from 'mobx'
import { ReactElement } from 'react'
import { getNextKey } from 'util/id'

const START = 500
const END = 500

export type NoticeType = 'info' | 'success' | 'error'
export type NoticeState = 'start' | 'open' | 'end'

export type Content = string | ReactElement

export class NoticeStore {
  readonly key = getNextKey()

  type: NoticeType
  content: Content
  state: NoticeState = 'start'


  private timeout_id?: TimeoutId
  private start_id?: TimeoutId


  constructor(type: NoticeType, content: Content, duration: number = 5000) {
    makeAutoObservable(this)
    this.type = type
    this.content = content
    this.timeout_id = setTimeout(() => this.close(), duration - START - END)
    this.start_id = setTimeout(() => this.open(), START)
  }

  close() {
    clearTimeout(this.timeout_id)
    clearTimeout(this.start_id)

    if(this.state === 'end') return

    this.state = 'end'
    setTimeout(() => this.remove(), END)
  }

  private open() {
    this.state = 'open'
  }

  private remove(){
    notice.remove(this)
  }
}
